import "styles/components/layouts/floatingInputWrapper.css";
import FloatingLabel from "shared/components/common/FloatingLabel";
import IconButton from "shared/components/forms/buttons/IconButton";

interface FloatingInputWrapperProps {
  id: string;
  placeholder: string;
  shrink?: boolean;
  children?: React.ReactNode;
  styleProps?: React.CSSProperties;
  iconName?: string;
}

const FloatingInputWrapper = ({
  id,
  placeholder,
  shrink = false,
  styleProps,
  children,
  iconName,
}: FloatingInputWrapperProps) => {
  return (
    <div style={styleProps} className="floatingInputContainer" tabIndex={-1}>
      {children}
      <FloatingLabel id={id} label={placeholder} shrink={shrink} />
      {iconName && (
        <IconButton
          iconName={iconName}
          svgProp={{ width: "16px", height: "16px" }}
          wrapperStyle={{
            alignContent: "center",
            marginTop: "5px",
            marginRight: "1rem",
          }}
        />
      )}
    </div>
  );
};

export default FloatingInputWrapper;
